// extracted by mini-css-extract-plugin
export default {"expired":"expired_expired__UDEfu","inner-container":"expired_inner-container__OlrFf","download-button":"expired_download-button__xNYqO"};